import { motion } from 'framer-motion';
import { useTranslation } from '../../context/LanguageContext';
import { homeWhyImage } from '../../assets/siteImages';
import { fadeUp, scrollViewport } from '../../motion/presets';
import './home-why.scss';

const HomeWhy = () => {
  const { content } = useTranslation();
  const w = content.home.why;

  return (
    <section className="parent-bg section-full" aria-labelledby="home-why-title">
      <div className="container home-why__shell">
        <motion.div
          className="home-why__card"
          initial="hidden"
          whileInView="visible"
          viewport={scrollViewport}
          variants={fadeUp}
        >
          <div className="home-why__card-inner">
            <div className="home-why__media">
              <img
                className="home-why__photo"
                src={homeWhyImage}
                alt={w.photoAlt}
                loading="lazy"
                decoding="async"
              />
            </div>

            <div className="home-why__copy">
              <div className="home-why__accent" aria-hidden="true" />
              <h2 id="home-why-title" className="home-why__title">
                {w.title}
              </h2>
              {w.lead ? <p className="home-why__lead">{w.lead}</p> : null}

              <ul className="list-checks home-why__list">
                {w.reasons.map((text) => (
                  <li key={text}>{text}</li>
                ))}
              </ul>

              <div className="home-why__rule-wrap">
                <hr className="divider-soft" />
              </div>
              <p className="home-why__closing">{w.closing}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeWhy;
